<script>
    import { auth, db, app } from './firebase';
    import { object } from 'rxfire/database';
    import { map } from 'rxjs/operators';
    import { parse, NodeType, stringifySVG } from 'svg-vdom';

    import {
        FileUploaderDropContainer,
        Form,
        FormGroup,
        Checkbox,
        RadioButtonGroup,
        RadioButton,
        Select,
        SelectItem,
        TextArea,
        TextInput,
        Button,
    } from "carbon-components-svelte";
    import TrashCan16 from "carbon-icons-svelte/lib/TrashCan16";

    // User ID passed from parent
    
    let cardId
    let cardData;
    let vdom;
    let textFields=[]; 
    let textXY=[];
    let textNodes=[];    
    // let svgObject;

    const ref = db.ref('cards');
    $: {
        if (cardData && cardData.info.svg)  {
            parse( cardData.info.svg )
                .then( parsed => {              
                    vdom = parsed;
                });
            };
        }

        $: {
            textFields=[]; textNodes=[]; textXY=[];
            if (vdom) {
                showVDom( vdom );
            }
        }

    // $: {

    //     svgObject = (cardData && cardData.info.svg) ?   JSON.stringify(parse(cardData.info.svg)) : null;
    //      if (cardData && cardData.info.svg)  {
    //         console.log(JSON.stringify( cardData.info.svg.getElementsByTagName('text')));
    //      }
    // }

function showVDom ( vdom ) {
    textNodes = vdom.querySelectorAll('tspan');
    textNodes.forEach(( textNode, index ) => {
        console.log(`Text Item ${index}: ${textNode.childNodes[0].textContent}`);
        textFields.push(textNode.childNodes[0].textContent);
        textFields=textFields;

    });
}

function getCard () {

    object(ref.child(cardId)).subscribe(change => {
      const { event, snapshot, prevKey } = change;
      console.log(event, ' will always be value');
      console.log(prevKey, ' the previous key');
      console.log(snapshot.val(), ' this is the data');
    });
    // Retrieve the data and key

    object(ref.child(cardId))
      .pipe(map(change => ({ _key: change.snapshot.key, ...change.snapshot.val() })))
      .subscribe(data => { cardData = data; });


}

function setCard ( data ) {

    ref.child(cardId).child("info").child("svg").set( cardData.info.svg );

}
function dropSVG( e ) {
    console.log( document.getElementById('svg_uploader').files[0] );
}

function makeBGCard(  ) {
  
    ref.child(cardId).child("info").child("background").set( true );    
    
}

 function handleOnSubmit ( e) {
    let fields = document.getElementsByName('SVGTextField');
    textNodes.forEach(( textNode, index ) => {
        console.log(` Form Text Item ${index}: ${fields[index].value}  OG Field: ${textNode.childNodes[0].textContent}`);
         textNode.childNodes[0].textContent = fields[index].value;
    });
    cardData.info.svg = stringifySVG(vdom);
    vdom=null;
 }

</script>

<style>
    input { display: block }
</style>



<input bind:value={cardId}>
<Button  on:click={getCard}>Get Card!</Button>

{#if cardData}
    {#if cardData.info.background}
          {@html cardData.info.svg}
          <Form on:submit={handleOnSubmit}>

          <FormGroup legendText="SVG Info">
<!--             <TextArea bind:value={ svgObject }
              labelText="SVG"
              helperText="SVG Content"
              placeholder="Blank"
            />
 -->     
        
        <ul>
            {#each textFields as textField, i}
                <TextInput
                  labelText="Background Label #{i}"
                  placeholder="Background Label"
                  name='SVGTextField'
                  id=text_{i}
                  value={textField}
                />
            {/each}

        </ul>       
          </FormGroup>
          <Button type="submit">Update Preview Labels</Button>
        <Button kind="danger" iconDescription="Destructive Save" icon={TrashCan16} on:click={setCard}>Save New Labels to Card</Button>
            <TextArea bind:value={cardData.info.svg}
              style="height: 30rem"
              labelText="SVG"
              helperText="SVG Content"
              placeholder="Blank"
            />
        </Form>



    {:else}
        <Button  on:click={makeBGCard}>Make Background Card</Button>
            <Form on:submit={handleOnSubmit}>

              <FormGroup legendText="Card Info">
                <TextInput bind:value={cardData.info.icon}
                  labelText="Icon"
                  helperText="Icon that appears on card"
                  placeholder="No Icon"
                />
                <TextInput bind:value={cardData.info.style}
                  labelText="Color"
                  helperText="Card Color"
                  placeholder="White"
                />
                <TextInput bind:value={cardData.info.title}
                  labelText="Title"
                  helperText="Title text on card"
                  placeholder="Blank"
                />
              </FormGroup>
              <Button type="submit">Submit</Button>
            </Form>

    {/if}
{/if}